var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "button-line" }, [
    _c(
      "div",
      [
        _c("Button", {
          attrs: {
            secondary: "",
            smaller: "",
            icon: "caret-right",
            text: "Passenden Job finden",
            href: "/jobfinden"
          }
        })
      ],
      1
    ),
    _vm._v(" "),
    _c("div", [_vm._v(_vm._s(_vm.middleText))]),
    _vm._v(" "),
    _c(
      "div",
      [
        _c("Button", {
          attrs: {
            icon: "caret-right",
            text: "Passende Mitarbeiter finden",
            href: "/kunde/eintragung"
          }
        })
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }